import { z } from 'zod';
import { WordSchemas } from './words';
import { WordCollectionSchemas } from './word-collections';
import { ValidationPatterns } from './shared';
export const GetTodayWordsRequestSchema = z.object({});
export const StartSessionRequestSchema = z.object({});
export const MarkLearnedRequestSchema = z.object({
  wordId: ValidationPatterns.flexibleObjectId,
});
export const ExpireTokenRequestSchema = z.object({});
export const AudioStreamRequestSchema = z.object({
  wordId: ValidationPatterns.flexibleObjectId,
  type: z.enum(['pronunciation', 'example']),
});
export const GetCollectionRequestSchema = z.object({
  id: ValidationPatterns.flexibleObjectId,
});
export const GetHistoryRequestSchema = z.object({});
export const GetTodayWordsDataSchema = z.object({
  words: z.array(WordSchemas.full),
});
export const StartSessionDataSchema = z.object({
  message: z.string(),
  expiresAt: z.string(),
  sessionAlreadyStarted: z.boolean(),
});
export const MarkLearnedDataSchema = z.object({
  message: z.string(),
  allWordsCompleted: z.boolean(),
  expiresAt: z.string().optional(),
});
export const ExpireTokenDataSchema = z.object({
  message: z.string(),
});
export const GetCollectionDataSchema = z.object({
  id: ValidationPatterns.flexibleObjectId,
  userId: ValidationPatterns.flexibleObjectId,
  date: ValidationPatterns.flexibleDate,
  words: z.array(WordSchemas.full),
  createdAt: ValidationPatterns.flexibleDate,
  updatedAt: ValidationPatterns.flexibleDate,
});
export const GetHistoryDataSchema = z.array(WordCollectionSchemas.display);
export const GetTodayWordsResponseSchema = z.object({
  success: z.boolean(),
  data: GetTodayWordsDataSchema,
  message: z.string(),
  meta: z
    .object({
      timestamp: z.string(),
    })
    .optional(),
});
export const StartSessionResponseSchema = z.object({
  success: z.boolean(),
  data: StartSessionDataSchema,
  message: z.string(),
  meta: z
    .object({
      timestamp: z.string(),
    })
    .optional(),
});
export const MarkLearnedResponseSchema = z.object({
  success: z.boolean(),
  data: MarkLearnedDataSchema,
  message: z.string(),
  meta: z
    .object({
      timestamp: z.string(),
    })
    .optional(),
});
export const ExpireTokenResponseSchema = z.object({
  success: z.boolean(),
  data: ExpireTokenDataSchema,
  message: z.string(),
  meta: z
    .object({
      timestamp: z.string(),
    })
    .optional(),
});
export const GetCollectionResponseSchema = z.object({
  success: z.boolean(),
  data: GetCollectionDataSchema,
  message: z.string(),
  meta: z
    .object({
      timestamp: z.string(),
    })
    .optional(),
});
export const GetHistoryResponseSchema = z.object({
  success: z.boolean(),
  data: GetHistoryDataSchema,
  message: z.string(),
  meta: z
    .object({
      timestamp: z.string(),
    })
    .optional(),
});
export type GetTodayWordsRequest = z.infer<typeof GetTodayWordsRequestSchema>;
export type StartSessionRequest = z.infer<typeof StartSessionRequestSchema>;
export type MarkLearnedRequest = z.infer<typeof MarkLearnedRequestSchema>;
export type ExpireTokenRequest = z.infer<typeof ExpireTokenRequestSchema>;
export type AudioStreamRequest = z.infer<typeof AudioStreamRequestSchema>;
export type GetCollectionRequest = z.infer<typeof GetCollectionRequestSchema>;
export type GetHistoryRequest = z.infer<typeof GetHistoryRequestSchema>;
export type GetTodayWordsData = z.infer<typeof GetTodayWordsDataSchema>;
export type StartSessionData = z.infer<typeof StartSessionDataSchema>;
export type MarkLearnedData = z.infer<typeof MarkLearnedDataSchema>;
export type ExpireTokenData = z.infer<typeof ExpireTokenDataSchema>;
export type GetCollectionData = z.infer<typeof GetCollectionDataSchema>;
export type GetHistoryData = z.infer<typeof GetHistoryDataSchema>;
export type GetTodayWordsResponse = z.infer<typeof GetTodayWordsResponseSchema>;
export type StartSessionResponse = z.infer<typeof StartSessionResponseSchema>;
export type MarkLearnedResponse = z.infer<typeof MarkLearnedResponseSchema>;
export type ExpireTokenResponse = z.infer<typeof ExpireTokenResponseSchema>;
export type GetCollectionResponse = z.infer<typeof GetCollectionResponseSchema>;
export type GetHistoryResponse = z.infer<typeof GetHistoryResponseSchema>;
export const LearningAPI = {
  requests: {
    GetTodayWords: GetTodayWordsRequestSchema,
    StartSession: StartSessionRequestSchema,
    MarkLearned: MarkLearnedRequestSchema,
    ExpireToken: ExpireTokenRequestSchema,
    AudioStream: AudioStreamRequestSchema,
    GetCollection: GetCollectionRequestSchema,
    GetHistory: GetHistoryRequestSchema,
  },
  responses: {
    GetTodayWords: GetTodayWordsResponseSchema,
    StartSession: StartSessionResponseSchema,
    MarkLearned: MarkLearnedResponseSchema,
    ExpireToken: ExpireTokenResponseSchema,
    GetCollection: GetCollectionResponseSchema,
    GetHistory: GetHistoryResponseSchema,
  },
} as const;
